/**
 * Loads the contents of an SVG file and injects it to where it's being called.
 * In its originality this function is only used with the Underscore templating
 * engine, so it only works if the template is being rendered right after
 * compilation.
 * @param  {String} icon The icon name. Consult with FEDs or the
 * [Pattern Library](https://patternlibrary.freelancer.com)
 *                       for the naming convention of the icon you're using.
 * @return {String}      A temporary placeholder element to be replaced later
 * after the XHR fetches the SVG.
 */

function generateUniqueIdentifier() {
  const identifier = `uiIcon-${Math.floor(Math.random() * 1024)}`;
  // Does the passwordless form with that identifier exist? Reroll the
  // dice again to get a new unique one.
  if (document.getElementById(identifier)) {
    return generateUniqueIdentifier();
  }

  return identifier;
}

export default function uiIcon(icon) {
  // Make a placeholder element to be replaced with the SVG later.
  const identifier = generateUniqueIdentifier();
  const placeholderHTML = `<span id="${identifier}"></span>`;

  // Fetch the contents of the SVG file we're going to replace it with.
  let placeholderNode;
  // DO NOT use the SystemJS API without talking to @laurent first! Things
  // might go really bad if you do.
  fetch(SystemJS.normalizeSync(`icons/${icon}.svg`))
  .then((response) => {
    if (response.ok) {
      return response.text();
    }

    // Remove the placeholder element if the icon is not found or some server
    // problems happened.
    placeholderNode = document.getElementById(`${identifier}`);
    if (placeholderNode.parentNode) {
      placeholderNode.parentNode.removeChild(placeholderNode);
    }
    throw new Error();
  })
  .then((html) => {
    const replace = function replace() {
      placeholderNode = document.getElementById(`${identifier}`);
      // Sometimes the templates are rendered but never inserted in the DOM
      // ¯\_(ツ)_/¯
      if (placeholderNode) {
        placeholderNode.outerHTML = html;
      }
    };

    // Replace the placeholder element at the next animation frame if possible.
    if ('requestAnimationFrame' in window) {
      requestAnimationFrame(replace);
    } else {
      replace();
    }
  // 404 or something else happened. Don't worry about it.
  })
  .catch(() => undefined);

  // While that call's happening return the placeholder element to be injected
  // to the template first.
  return placeholderHTML;
}
